import { CalendarCheck, Phone } from "lucide-react";
import { SITE } from "../lib/site";
import { Link } from "react-router-dom";

export default function StickyBar() {
  return (
    <div
      data-testid="sticky-cta-bar"
      translate="no"
      lang="it"
      className="notranslate fixed bottom-0 left-0 right-0 z-40 md:hidden"
      style={{ paddingBottom: "env(safe-area-inset-bottom)" }}
    >
      <div className="mx-auto max-w-3xl px-3 pb-3 pt-2">
        <div className="bg-[var(--ee-ink)]/95 backdrop-blur-md border border-white/10 rounded-full shadow-[0_18px_45px_-15px_rgba(0,0,0,0.45)] flex items-center gap-2 p-1.5">
          <a
            href={SITE.phoneTel}
            data-testid="sticky-call-btn"
            className="flex-1 flex items-center justify-center gap-2 rounded-full px-4 py-3 text-[13px] sm:text-[14px] font-semibold bg-[var(--ee-ivory)] text-[var(--ee-ink)] border border-[var(--ee-ivory)] hover:bg-white transition-colors"
          >
            <Phone size={16} strokeWidth={2} />
            Chiama ora
          </a>
          <Link
            to="/prenota"
            data-testid="sticky-book-btn"
            className="flex-1 flex items-center justify-center gap-2 rounded-full px-4 py-3 text-[13px] sm:text-[14px] font-semibold bg-[var(--ee-rose-strong)] text-white hover:bg-[#a44a6c] transition-colors"
          >
            <CalendarCheck size={16} strokeWidth={1.9} />
            Prenota online
          </Link>
        </div>
      </div>
    </div>
  );
}
